import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import * as types from 'modules/auth/actionTypes';
import { LOGIN_STEPS } from 'modules/auth/constant';
import type { SetAuthStepAction } from 'modules/auth/types';
import { createReducer } from 'utils/ReduxUtils';

const initialState: LOGIN_STEPS = LOGIN_STEPS.LOGIN;

const setStep = (_: LOGIN_STEPS, { payload }: SetAuthStepAction): LOGIN_STEPS => payload.step;

const reset = (): LOGIN_STEPS => initialState;

export default createReducer(initialState, {
  [types.SET_AUTH_STEP]: setStep,
  [types.SIGN_OUT_REQUEST]: reset,
  [types.SIGN_OUT_EMERGENCY]: reset,
  [USER_LOGOUT_CLEAR]: reset,
});
